module.exports = __webpack_public_path__ + "static/media/vityarthilogo.f7b209c6.jpg";